<template>
  <div class="content">
    <h1 class="has-text-centered">VGA-Anschluss Belegung</h1>
    <div class="box">
      <p class="is-size-7-mobile">
          Bei VGA (<strong>V</strong>ideo <strong>G</strong>raphics <strong>A</strong>rray) handelt es sich um einen Standard für Grafikkarten. Obwohl moderne Grafikkarten keine VGA-Anschlüsse mehr haben, hat sich VGA zur Übertragung von analogen Bildsignalen lange gehalten.
      </p>
    </div>
    <div class="box has-text-centered">
      <img src="@/assets/images/pinouts/Pinout-VGA.svg">
      <p class="is-size-7-mobile">
        <strong>Die Buchse in Steckrichtung</strong><br>
        Bild von <a target="_blank" href="https://de.wikipedia.org/wiki/VGA-Anschluss">https://de.wikipedia.org/wiki/VGA-Anschluss</a>
      </p>
    </div>
    <div class="box">
      <div class="has-overflow-x-auto">
        <table class="table is-hoverable is-striped is-bordered has-text-centered is-size-7-mobile">
          <thead>
            <tr>
              <th class="th-pins">Pin</th>
              <th class="th-pins">Funktion</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Rot (0,7 V<sub>ss</sub> @ 75 Ohm)</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Grün (Pegel und Impedanz) oder (analoges) Monochromsignal</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Blau (Pegel und Impedanz)</td>
            </tr>
            <tr>
              <td>4</td>
              <td>ID2 (Monitor-<strong>ID</strong>entifizierung #2) oder Reserve</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Digitale Masse für DDC</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Analoge Masse für Rot</td>
            </tr>
            <tr>
              <td>7</td>
              <td>Analoge Masse für Grün</td>
            </tr>
            <tr>
              <td>8</td>
              <td>Analoge Masse für Blau</td>
            </tr>
            <tr>
              <td>9</td>
              <td>Nicht belegt; glgt. +5 V von der Grafikkarte (= Computer angeschlossen)</td>
            </tr>
            <tr>
              <td>10</td>
              <td>Analoge Masse für Synchronsignale</td>
            </tr>
            <tr>
              <td>11</td>
              <td>ID0</td>
            </tr>
            <tr>
              <td>12</td>
              <td>ID1 oder digit. Datenaustausch (DDC – <router-link :to="{name: 'glossary-s', hash: '#SDA'}">SDA, Serial Data = Datenleitung</router-link>)</td>
            </tr>
            <tr>
              <td>13</td>
              <td>Horizontale Synchronisation oder gemeinsame Sync. (H + V)</td>
            </tr>
            <tr>
              <td>14</td>
              <td>Vertikale Synchronisation</td>
            </tr>
            <tr>
              <td>15</td>
              <td>Digit. Datenaustausch (DDC – <router-link :to="{name: 'glossary-s', hash: '#SCL'}">SCL, Serial Clock = Taktleitung</router-link>)</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pins-vga',
  metaInfo: {
    title: 'VGA Pins | Elektrotechik-Rechner.at',
    meta: [
      {
        name: 'description',
        content: 'Bei VGA (Video Graphics Array) handelt es sich um einen Standard für Grafikkarten.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: '<span class="fas fa-angle-left"></span> Zurück', route: 'pins' })
  }
}
</script>
